export default {
    useReportFilter: false,
    texts: {
        count:
            'Showing {from} to {to} of {count} records|{count} records|One record',
        filteredCount:
            'Showing {from} to {to} of {count} records (filtered from {total} total entries)|{count} records (filtered from {total} total entries)|One record (filtered from {total} total entries)',
        limit: 'Records per page :',
        filterPlaceholder: 'Search...',
        loading: 'Loading...',
        filter: '',
        title: null,
        description: null,
        detail: null,
    },
    compileTemplates: true,
    highlightMatches: true,
    pagination: {
        dropdown: false,
        chunk: 5,
    },
    checkbox: false,
    filterByColumn: false,
    datepickerOptions: {
        showDropdowns: true,
    },
    actionButtons: [],
    exports: {},
    pdf_url: false,
    csv_url: false,
    xlsx_url: false,
    json_url: false,
    create_btn: {},
    checkboxActions: [],
    // will be remove later
    checkbox_actions: {},
    perPage: 20,
    perPageValues: [20, 50, 100],
    skin: 'table-striped table-hover table m-b-0 b-b',
    sortIcon: {
        is: 'sorting',
        up: 'sorting asc',
        down: 'sorting desc',
    },
    checkboxDisableCallback: row => false,
    export_post: false,
    export_filename: null,
    footer: true,
};
